import React from "react";
import "./TripForm.scss";
import VesselPermit from "../../components/VesselPermit";
import SailDate from "../../components/SailDate";
import useScrollToTop from "../../components/CustomHooks/useScrollToTop";

export default function TripForm(props) {
  useScrollToTop();

  if (props.currentStep !== 1) {
    return null;
  }

  return (
    <div className="trip-form-container" id={"trip_form"}>
      <SailDate
        handleSailDateChange={props.handleSailDateChange}
        display_date_sail={props.display_date_sail}
        sailDateNowHandler={props.sailDateNowHandler}
        helpText={props.helpText}
      />
      <VesselPermit
        changeHandler={props.handlePermitChange}
        vessel_permit_options={props.vessel_permit_options}
        vessel_permit_num={props.vessel_permit_num}
        vessel_name={props.vessel_name}
        vessel_registration={props.vessel_registration}
        handleTripPermitPreferenceChange={
          props.handleTripPermitPreferenceChange
        }
        preferences={props.preferences.vessel}
        helpText={props.helpText}
      />
    </div>
  );
}
